import { render, staticRenderFns } from "./LocateCollection.vue?vue&type=template&id=4bf10652"
import script from "./LocateCollection.vue?vue&type=script&lang=js"
export * from "./LocateCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports